import {EmailPromotionType} from '@optimaxdev/analytics/desktop/types';
import {createAction} from '@reduxjs/toolkit';

import {FieldType} from 'desktop/pages/checkout/types/fieldType';

export const startCheckoutSaga = createAction('CHECKOUT@START_CHECKOUT_SAGA');

export const startSetCheckoutStepSaga = createAction<string>(
    'CHECKOUT@START_SET_CHECKOUT_STEP_SAGA',
);

export const startDeliveryStepSaga = createAction(
    'CHECKOUT@DELIVERY_STEP@START_DELIVERY_STEP_SAGA',
);

export const finishDeliveryStep = createAction('CHECKOUT@DELIVERY_STEP@FINISH_DELIVERY_STEP');

export const routerInfoUpdated = createAction('ROUTER_INFO@UPDATED');

export const saveDataForDeliveryStepWithoutValid = createAction(
    'CHECKOUT@DELIVERY_STEP@SAVE_DATA_FOR_DELIVERY_STEP_WITHOUT_VALID',
);

export const setAddressFieldValue = createAction<FieldType>(
    'CHECKOUT@DELIVERY_STEP@SET_ADDRESS_FIELD_VALUE',
);

export const setShippingMethodsOnAutocomplete = createAction(
    'CHECKOUT@DELIVERY_STEP@SET_SHIPPING_METHOD_ON_AUTOCOMPLETE',
);

export const setSubscribeCheckboxStatus = createAction<EmailPromotionType>(
    'CHECKOUT@REVIEW_STEP@SET_SUBSCRIBTION_CHECKBOX_STATUS',
);
